import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftCallingProductThreshold,
  MicrosoftSuggestedProduct,
  MicrosoftSuggestedProductRequest,
} from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftCallingProductThresholdsResource {
  private http = inject(HttpClient);

  private _url = '';

  get(): Observable<MicrosoftCallingProductThreshold> {
    return this.http.get<MicrosoftCallingProductThreshold>(this._url);
  }

  put(body: MicrosoftCallingProductThreshold): Observable<void> {
    return this.http.put<void>(this._url, body);
  }

  getSuggestedProducts(body: MicrosoftSuggestedProductRequest): Observable<MicrosoftSuggestedProduct> {
    return this.http.post<MicrosoftSuggestedProduct>(
      '/services/microsoft/admin/calling-product-thresholds/suggested-products',
      body,
    );
  }

  setUrl(tenantId: number): void {
    this._url = `/services/microsoft/admin/tenant/${tenantId}/calling-product-thresholds`;
  }
}
